import axios from 'axios'
import { apiLivechat } from '../config/env'
let headers = {
    'content-type': 'multipart/form-data',
}
const axiosIntanceApiZalo = axios.create({
    withCredentials: false,
    baseURL: apiLivechat,
    headers: headers
})
axiosIntanceApiZalo.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosIntanceApiZalo.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosIntanceApiZalo